import { ReactNode } from 'react';
import PurchaseRestrictionModal from './PurchaseRestrictionModal';

export interface PurchaseRestrictionModalProps {
  title: string;
  text: string;
  buttonLabel: string;
  dataComponentName: string;
}

function PurchaseRestrictionModalWrapper(
  props: Readonly<PurchaseRestrictionModalProps>
): ReactNode {
  return <PurchaseRestrictionModal {...props} />;
}

PurchaseRestrictionModalWrapper.aemResourceType =
  'b2c-website-foundation/components/mymsc/purchaserestrictionmodal';

export default PurchaseRestrictionModalWrapper;
